import React from "react";
import ReactDOM from "react-dom/client";
import "@/sentry"; // Sentry init - no-op when REACT_APP_SENTRY_DSN is empty.
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
